// extracted by mini-css-extract-plugin
export default {"recommendedProducts":"product-detail_recommendedProducts__jyU8S","bgGrey":"product-detail_bgGrey__2i-J3","container":"product-detail_container__5+n5Q"};